// extracted by mini-css-extract-plugin
export default {"flagCard":"StaffFormParts_flagCard__0nKkw","flagText":"StaffFormParts_flagText__LQN8m"};